import { createRoot } from 'react-dom/client'
import { useState } from 'react'

const rootElement = document.getElementById('tranding-systems-iframes')
const root = createRoot(rootElement)
root.render(<TradingSystems />)

function TradingSystems() {

    const tabData = [
        {name: 'system', label: 'System Ranking', url: 'https://systemtradingcenter.com/systems/yif_rjofutures.php?page=04ranking', height: "3500px"},
        {name: 'actual', label: 'Actual Performance', url: 'https://systemtradingcenter.com/systems/yif_rjofutures.php?page=02actual', height: "3750px"},
        {name: 'daily', label: 'Daily Results', url: 'https://systemtradingcenter.com/systems/yif_rjofutures.php?page=03daily', height: "3500px"},
        {name: 'about', label: 'About Trading Systems', url: 'https://systemtradingcenter.com/systems/yif_rjofutures.php?page=01system', height: "1300px"}
    ]

    const [currentTabIndex, setCurrentTabIndex] = useState(0)

    return <div>
        <div className="tab-group">
        {
            tabData.map((tab, idx) => (
                <button className={idx === currentTabIndex && "active"} onClick={() => setCurrentTabIndex(idx)}>{tab.label}</button>
            ))
        }
        </div>
        
        <iframe src={tabData[currentTabIndex].url} name="striframe" height={tabData[currentTabIndex].height} width="100%" frameborder="0"></iframe>
    </div>
}